<template>
  <router-view />
</template>

<script>
export default {
  name: "projectHome",
  data () {
    return {};
  },
  components: {},
  methods: {},
};
</script>
<style lang="less" scoped>
.projectHome {
  height: 100%;
}
</style>